import type {
  AdminAccountDeletionStatus,
  AdminJobStatus,
  AdminUserDataRiskLevel,
} from "../../contracts/admin-read-models";
import type { AdminDashboardRuntimeConfig } from "../../app/composition/admin-dashboard-runtime-config";
import type { AdminDashboardLocale } from "./admin-dashboard-locale";
import { pickAdminDashboardLocaleText } from "./admin-dashboard-copy";

export function formatAdminAuthModeLabel(
  authMode: AdminDashboardRuntimeConfig["authMode"],
  locale: AdminDashboardLocale,
): string {
  switch (authMode) {
    case "fixture":
      return pickAdminDashboardLocaleText(locale, { en: "Fixture", ko: "픽스처" });
    case "admin-auth":
      return pickAdminDashboardLocaleText(locale, { en: "Admin auth", ko: "관리자 인증" });
    default:
      return authMode;
  }
}

export function formatAdminJobStatusLabel(
  status: AdminJobStatus,
  locale: AdminDashboardLocale,
): string {
  switch (status) {
    case "queued":
      return pickAdminDashboardLocaleText(locale, { en: "Queued", ko: "대기" });
    case "processing":
      return pickAdminDashboardLocaleText(locale, { en: "Processing", ko: "처리 중" });
    case "succeeded":
      return pickAdminDashboardLocaleText(locale, { en: "Succeeded", ko: "성공" });
    case "failed":
      return pickAdminDashboardLocaleText(locale, { en: "Failed", ko: "실패" });
    default:
      return status;
  }
}

export function formatAdminAccountDeletionStatusLabel(
  status: AdminAccountDeletionStatus,
  locale: AdminDashboardLocale,
): string {
  switch (status) {
    case "none":
      return pickAdminDashboardLocaleText(locale, { en: "None", ko: "없음" });
    case "queued":
      return pickAdminDashboardLocaleText(locale, { en: "Queued", ko: "대기" });
    case "processing":
      return pickAdminDashboardLocaleText(locale, { en: "Processing", ko: "처리 중" });
    case "succeeded":
      return pickAdminDashboardLocaleText(locale, { en: "Succeeded", ko: "완료" });
    case "failed":
      return pickAdminDashboardLocaleText(locale, { en: "Failed", ko: "실패" });
    default:
      return status;
  }
}

export function formatAdminRiskLevelLabel(
  level: AdminUserDataRiskLevel,
  locale: AdminDashboardLocale,
): string {
  switch (level) {
    case "attention":
      return pickAdminDashboardLocaleText(locale, { en: "Attention", ko: "주의" });
    case "warning":
      return pickAdminDashboardLocaleText(locale, { en: "Warning", ko: "경고" });
    case "critical":
      return pickAdminDashboardLocaleText(locale, { en: "Critical", ko: "치명" });
    default:
      return level;
  }
}
